import { USER_CENTER_ENDPOINTS } from './endpoints';
import { request } from './http';
import { grantAdminTreeSchema, parseOrThrow, treeSchema } from './schemas';
import type { GrantAdminTreeDto, TreeDto } from './schemas';

export const fetchCatalogue = async (signal?: AbortSignal): Promise<TreeDto> =>
  parseOrThrow(treeSchema, await request('get', USER_CENTER_ENDPOINTS.TREE, { signal }), 'permission tree');

export const fetchGrantAdminTree = async (grant: string, signal?: AbortSignal): Promise<GrantAdminTreeDto> =>
  parseOrThrow(
    grantAdminTreeSchema,
    await request('get', USER_CENTER_ENDPOINTS.TREE, { params: { grant, plane: 'admin' }, signal }),
    'grant admin tree',
  );
